import React from 'react';
import PropTypes from 'prop-types';
import { VelocityComponent } from 'velocity-react';
import { connect } from 'react-redux';
import { clearToast } from './actions';
import { getToastAttribute } from './reducer';
import RenderInBody from '../RenderInBody';
import Icon from '../icon/Icon';

const mapTypeToIconNames = type => {
  switch (type) {
    case 'success':
      return 'filled-check';
    default:
      return 'filled-x';
  }
};

export const Toast = ({ message, type, isVisible, clearToast }) => (
  <RenderInBody>
    <VelocityComponent animation={{ translateY: isVisible ? '0%' : '-100%' }} display={isVisible ? 'block' : 'none'}>
      <div className='toast p4-sm' onClick={clearToast}>
        <div className='content-wrapper'>
          <div className='icon-container'>
            <Icon name={mapTypeToIconNames(type)} alt='' />
          </div>
          <div className='message-container'>{message}</div>
        </div>
      </div>
    </VelocityComponent>
  </RenderInBody>
);

Toast.defaultProps = {
  message: '',
  type: ''
};

Toast.propTypes = {
  message: PropTypes.string,
  type: PropTypes.string,
  isVisible: PropTypes.bool.isRequired,
  clearToast: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  message: getToastAttribute(state, 'message'),
  type: getToastAttribute(state, 'type'),
  isVisible: getToastAttribute(state, 'isVisible')
});

export default connect(mapStateToProps, { clearToast })(Toast);
